

















import Vue from "vue";

export default Vue.extend({
  name: "BaseLoading",

  data() {
    return {
      isVisible: false,
    };
  },

  created() {
    this.$root.$on("show-base-loading", () => {
      this.isVisible = true;
    });
    this.$root.$on("hide-base-loading", () => {
      this.isVisible = false;
    });
  },
});
